import { useState } from 'react';
import { FiDownload } from 'react-icons/fi';

import { baixarBlob, baixarImagem } from 'utils/baixar-imagem';
import { FOCO_VISIVEL } from 'utils/foco';

// D3: o "Baixar" do Meu Perfil v2 (11px, 0.04em, padding 11px 10px, raio de 6px) não é um tamanho do `Button`.
// Texto em azul-escuro, e não no azul do design: azul sobre amarelo fica em 4,44:1 (WCAG 1.4.3).
export const ACAO_BAIXAR = `flex w-full cursor-pointer items-center justify-center gap-[7px] rounded-[6px] border-0 bg-brand-yellow px-2.5 py-[11px] font-display text-[11px] font-bold uppercase tracking-[0.04em] text-brand-blue-dark transition duration-150 hover:bg-button-primary-hover disabled:cursor-wait motion-reduce:transition-none ${FOCO_VISIVEL}`;

interface BaixarSeloProps {
  /** A url da moldura com a foto, ou quem desenha a moldura "Só o selo" no navegador. */
  origem: string | (() => Promise<Blob>);
  /** Nome do arquivo baixado. */
  arquivo: string;
  /**
   * Complemento do nome acessível, só para leitor de tela ("do selo X, ciclo Y"). Vem depois do texto visível,
   * para o nome falado começar pelo que está escrito (WCAG 2.5.3) e acompanhar o "Baixando…".
   */
  complemento?: string;
}

/** "Baixar" da moldura, com o nome do arquivo, "Baixando…" e o alerta de falha (SEL-21, SEL-26, AJ2-37). */
export default function BaixarSelo({ origem, arquivo, complemento }: BaixarSeloProps) {
  const [baixando, setBaixando] = useState(false);
  const [erro, setErro] = useState(false);

  async function baixar() {
    setErro(false);
    setBaixando(true);
    try {
      if (typeof origem === 'string') await baixarImagem(origem, arquivo);
      else baixarBlob(await origem(), arquivo);
    } catch (e) {
      console.error(e);
      setErro(true);
    } finally {
      setBaixando(false);
    }
  }

  return (
    <>
      <button type="button" className={ACAO_BAIXAR} onClick={baixar} disabled={baixando}>
        <FiDownload aria-hidden="true" size={15} strokeWidth={2.4} />
        <span>
          {baixando ? 'Baixando…' : 'Baixar'}
          {complemento && <span className="sr-only"> {complemento}</span>}
        </span>
      </button>
      {erro && (
        <p role="alert" className="m-0 text-[13px] text-content">
          Não foi possível baixar o selo. Tente novamente.
        </p>
      )}
    </>
  );
}
